module.exports = __webpack_public_path__ + "img/type_struct_to_json.4a2ee4f3.png";